import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'lowest_wage_grade_level_average_monthly_overtime_earnings_male'

export const dataPointDefinition = {
  retracedId: 'lowest_wage_grade_level_average_monthly_overtime_earnings_male',
  name: 'Lowest wage grade / level: Average monthly overtime earnings - male',
  description:
    'In the lowest wage grade / level in the facility, what is the average monthly overtime earnings for male workers?\r\r\n\r\r\n"Average monthly" means the average calculated by month taking a period of 12 months into account. \r\r\n\r\r\n"Overtime earnings" means pay earned for hours performed outside of regular daily, weekly, or monthly working hours, including any overtime performed at night, on weekly rest days, or on public holidays.',
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-wage-43',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 8080,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
